import { NavLink } from "../core/layouts/types";
import { UserRole } from "../redux/features/user-slice";
import paths from "./paths";
import {
  adminCat,
  builderCat,
  manufacturingCat,
  merchantCat,
} from "../core/utils/constants";

export const settingsNavigation: NavLink[] = [
  {
    id: "profile",
    type: "link",
    title: "Profile",
    path: paths.PROFILE,
    category: [],
    role: [],
  },
  {
    id: "changePassword",
    type: "link",
    title: "Change Password",
    path: paths.CHANGE_PASSWORD,
    category: [],
    role: [],
  },
  // {
  //   id: "taskProperties",
  //   type: "section",
  //   title: "Task Properties",
  //   category: [],
  //   role: [
  //     UserRole.Admin,
  //     UserRole.Manager,
  //     UserRole.Supervisor,
  //     UserRole.Leader,
  //     UserRole.Contributor,
  //   ],
  // },
  // {
  //   id: "recurrences",
  //   type: "link",
  //   title: "Recurrences",
  //   path: paths.RECURRENCES,
  //   category: [],
  //   role: [UserRole.Manager, UserRole.Leader, UserRole.Contributor],
  // },
  // {
  //   id: "recurrencesManagement",
  //   type: "link",
  //   title: "Recurrences",
  //   category: [],
  //   role: [UserRole.Admin, UserRole.Supervisor],
  //   child: [
  //     {
  //       id: `${paths.RECURRENCES}/${adminCat.name}/${adminCat.id}`,
  //       type: "link",
  //       title: adminCat.name,
  //       path: `${paths.RECURRENCES}/${adminCat.name}/${adminCat.id}`,
  //       category: [adminCat.id],
  //       role: [UserRole.Admin, UserRole.Supervisor],
  //     },
  //     {
  //       id: `${paths.RECURRENCES}/${manufacturingCat.name}/${manufacturingCat.id}`,
  //       type: "link",
  //       title: manufacturingCat.name,
  //       path: `${paths.RECURRENCES}/${manufacturingCat.name}/${manufacturingCat.id}`,
  //       category: [adminCat.id, manufacturingCat.id],
  //       role: [UserRole.Admin, UserRole.Supervisor],
  //     },
  //     {
  //       id: `${paths.RECURRENCES}/${merchantCat.name}/${merchantCat.id}`,
  //       type: "link",
  //       title: merchantCat.name,
  //       path: `${paths.RECURRENCES}/${merchantCat.name}/${merchantCat.id}`,
  //       category: [adminCat.id, merchantCat.id],
  //       role: [UserRole.Admin, UserRole.Supervisor],
  //     },
  //     {
  //       id: `${paths.RECURRENCES}/${builderCat.name}/${builderCat.id}`,
  //       type: "link",
  //       title: builderCat.name,
  //       path: `${paths.RECURRENCES}/${builderCat.name}/${builderCat.id}`,
  //       category: [adminCat.id, builderCat.id],
  //       role: [UserRole.Admin, UserRole.Supervisor],
  //     },
  //   ],
  // },
  // {
  //   id: "jobTypes",
  //   type: "link",
  //   title: "Job Types",
  //   path: paths.JOB_TYPES,
  //   team: [dcTeam.id],
  //   role: [UserRole.Manager, UserRole.Leader, UserRole.Contributor],
  // },
  // {
  //   id: "JobTypesManagement",
  //   type: "link",
  //   title: "Job Types",
  //   team: [mgTeam.id, dcTeam.id],
  //   role: [UserRole.Admin, UserRole.Supervisor],
  //   child: [
  //     {
  //       id: `${paths.JOB_TYPES}/${dcTeam.name}/${dcTeam.id}`,
  //       type: "link",
  //       title: dcTeam.name,
  //       path: `${paths.JOB_TYPES}/${dcTeam.name}/${dcTeam.id}`,
  //       team: [mgTeam.id, dcTeam.id],
  //       role: [UserRole.Admin, UserRole.Supervisor],
  //     },
  //   ],
  // },
  // {
  //   id: "relationshipStatus",
  //   type: "link",
  //   title: "Relationship Status",
  //   path: paths.RELATIONSHIP_STATUS,
  //   team: [dcTeam.id],
  //   role: [UserRole.Manager, UserRole.Leader, UserRole.Contributor],
  // },
  // {
  //   id: "relationshipStatusManagement",
  //   type: "link",
  //   title: "Relationship Status",
  //   team: [mgTeam.id, dcTeam.id],
  //   role: [UserRole.Admin, UserRole.Supervisor],
  //   child: [
  //     {
  //       id: `${paths.RELATIONSHIP_STATUS}/${dcTeam.name}/${dcTeam.id}`,
  //       type: "link",
  //       title: dcTeam.name,
  //       path: `${paths.RELATIONSHIP_STATUS}/${dcTeam.name}/${dcTeam.id}`,
  //       team: [mgTeam.id, dcTeam.id],
  //       role: [UserRole.Admin, UserRole.Supervisor],
  //     },
  //   ],
  // },
  // {
  //   id: "requestTypes",
  //   type: "link",
  //   title: "Request Types",
  //   path: paths.REQUEST_TYPES,
  //   team: [dcTeam.id],
  //   role: [UserRole.Manager, UserRole.Leader, UserRole.Contributor],
  // },
  // {
  //   id: "requestTypesManagement",
  //   type: "link",
  //   title: "Request Types",
  //   team: [mgTeam.id, dcTeam.id],
  //   role: [UserRole.Admin, UserRole.Supervisor],
  //   child: [
  //     {
  //       id: `${paths.REQUEST_TYPES}/${dcTeam.name}/${dcTeam.id}`,
  //       type: "link",
  //       title: dcTeam.name,
  //       path: `${paths.REQUEST_TYPES}/${dcTeam.name}/${dcTeam.id}`,
  //       team: [mgTeam.id, dcTeam.id],
  //       role: [UserRole.Admin, UserRole.Supervisor],
  //     },
  //   ],
  // },
  {
    id: "summaryProperties",
    type: "section",
    title: "Summary Properties",
    category: [adminCat.id],
    role: [UserRole.Admin, UserRole.Supervisor],
  },
  {
    id: "reasonsManagement",
    type: "link",
    title: "Reasons",
    category: [],
    role: [UserRole.Admin, UserRole.Supervisor],
    child: [
      {
        id: `${paths.REASONS}/${adminCat.name}/${adminCat.id}`,
        type: "link",
        title: adminCat.name,
        path: `${paths.REASONS}/${adminCat.name}/${adminCat.id}`,
        category: [adminCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.REASONS}/${manufacturingCat.name}/${manufacturingCat.id}`,
        type: "link",
        title: manufacturingCat.name,
        path: `${paths.REASONS}/${manufacturingCat.name}/${manufacturingCat.id}`,
        category: [adminCat.id, manufacturingCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.REASONS}/${merchantCat.name}/${merchantCat.id}`,
        type: "link",
        title: merchantCat.name,
        path: `${paths.REASONS}/${merchantCat.name}/${merchantCat.id}`,
        category: [adminCat.id, merchantCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.REASONS}/${builderCat.name}/${builderCat.id}`,
        type: "link",
        title: builderCat.name,
        path: `${paths.REASONS}/${builderCat.name}/${builderCat.id}`,
        category: [adminCat.id, builderCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
    ],
  },
  {
    id: "challengesManagement",
    type: "link",
    title: "Challenges",
    category: [],
    role: [UserRole.Admin, UserRole.Supervisor],
    child: [
      {
        id: `${paths.CHALLENGES}/${adminCat.name}/${adminCat.id}`,
        type: "link",
        title: adminCat.name,
        path: `${paths.CHALLENGES}/${adminCat.name}/${adminCat.id}`,
        category: [adminCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.CHALLENGES}/${manufacturingCat.name}/${manufacturingCat.id}`,
        type: "link",
        title: manufacturingCat.name,
        path: `${paths.CHALLENGES}/${manufacturingCat.name}/${manufacturingCat.id}`,
        category: [adminCat.id, manufacturingCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.CHALLENGES}/${merchantCat.name}/${merchantCat.id}`,
        type: "link",
        title: merchantCat.name,
        path: `${paths.CHALLENGES}/${merchantCat.name}/${merchantCat.id}`,
        category: [adminCat.id, merchantCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.CHALLENGES}/${builderCat.name}/${builderCat.id}`,
        type: "link",
        title: builderCat.name,
        path: `${paths.CHALLENGES}/${builderCat.name}/${builderCat.id}`,
        category: [adminCat.id, builderCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
    ],
  },
  {
    id: "issuesManagement",
    type: "link",
    title: "Issues",
    category: [],
    role: [UserRole.Admin, UserRole.Supervisor],
    child: [
      {
        id: `${paths.ISSUES}/${adminCat.name}/${adminCat.id}`,
        type: "link",
        title: adminCat.name,
        path: `${paths.ISSUES}/${adminCat.name}/${adminCat.id}`,
        category: [adminCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.ISSUES}/${manufacturingCat.name}/${manufacturingCat.id}`,
        type: "link",
        title: manufacturingCat.name,
        path: `${paths.ISSUES}/${manufacturingCat.name}/${manufacturingCat.id}`,
        category: [adminCat.id, manufacturingCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.ISSUES}/${merchantCat.name}/${merchantCat.id}`,
        type: "link",
        title: merchantCat.name,
        path: `${paths.ISSUES}/${merchantCat.name}/${merchantCat.id}`,
        category: [adminCat.id, merchantCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.ISSUES}/${builderCat.name}/${builderCat.id}`,
        type: "link",
        title: builderCat.name,
        path: `${paths.ISSUES}/${builderCat.name}/${builderCat.id}`,
        category: [adminCat.id, builderCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
    ],
  },
  {
    id: "resourcesManagement",
    type: "link",
    title: "Support Resources",
    category: [],
    role: [UserRole.Admin, UserRole.Supervisor],
    child: [
      {
        id: `${paths.SUPPORT_RESOURCES}/${adminCat.name}/${adminCat.id}`,
        type: "link",
        title: adminCat.name,
        path: `${paths.SUPPORT_RESOURCES}/${adminCat.name}/${adminCat.id}`,
        category: [adminCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.SUPPORT_RESOURCES}/${manufacturingCat.name}/${manufacturingCat.id}`,
        type: "link",
        title: manufacturingCat.name,
        path: `${paths.SUPPORT_RESOURCES}/${manufacturingCat.name}/${manufacturingCat.id}`,
        category: [adminCat.id, manufacturingCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.SUPPORT_RESOURCES}/${merchantCat.name}/${merchantCat.id}`,
        type: "link",
        title: merchantCat.name,
        path: `${paths.SUPPORT_RESOURCES}/${merchantCat.name}/${merchantCat.id}`,
        category: [adminCat.id, merchantCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
      {
        id: `${paths.SUPPORT_RESOURCES}/${builderCat.name}/${builderCat.id}`,
        type: "link",
        title: builderCat.name,
        path: `${paths.SUPPORT_RESOURCES}/${builderCat.name}/${builderCat.id}`,
        category: [adminCat.id, builderCat.id],
        role: [UserRole.Admin, UserRole.Supervisor],
      },
    ],
  },
];
